import { render, staticRenderFns } from "./lobby.vue?vue&type=template&id=20e3a022&"
import script from "./lobby.vue?vue&type=script&lang=js&"
export * from "./lobby.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports